import { usePromotion } from '@barkinglabs/promotions-react';
import { PromotionConfigurationKind } from '@barkinglabs/promotions-types';
import { useLocale } from '../contexts/LocaleContext';
import { webApiUrl } from '../lib/fi-api/apiUtils';
import { resolvePromotionCouponCode } from '../lib/resolvePromotionCouponCode';

/**
 * Returns the locale-resolved coupon code for the currently active simple
 * promotion, or `undefined` if no promotion is active for the user's country
 * or the active variant is not the SIMPLE kind.
 *
 * Mirrors the resolution inside `useShopPromotionBannerDetails` so the code
 * we look up details for matches the code displayed on the promo banner.
 */
export function useActivePromoCode(): string | undefined {
  const { language, country } = useLocale();
  const { variant } = usePromotion({ overrideApiHost: webApiUrl, country });

  if (variant?.configuration.kind !== PromotionConfigurationKind.SIMPLE) {
    return undefined;
  }
  return resolvePromotionCouponCode(variant.configuration, language, country);
}
